import { Alert, Button, Select, Typography } from "antd";
import { BookingUser, getBookingUserName } from "lib/bookingUsers";
import { getBookingFilterMessages } from "i18n/bookingFilters";
import { useIntl } from "react-intl";

export const BookingUserSelect = ({
  users,
  value,
  onChange,
  isLoading,
  isError,
  onRetry,
  emptyMessage,
  selectedLabel,
}: {
  users: BookingUser[];
  value: string;
  onChange: (userId: string) => void;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  emptyMessage?: string;
  selectedLabel?: string;
}) => {
  const { locale } = useIntl();
  const copy = getBookingFilterMessages(locale);
  return (
    <div>
      <Typography.Text strong>{copy.specialist}</Typography.Text>
      <Select
        aria-label={copy.specialist}
        style={{ width: "100%", marginTop: 5 }}
        showSearch
        allowClear
        optionFilterProp="label"
        loading={isLoading}
        disabled={isLoading && !value}
        value={value || undefined}
        placeholder={copy.anySpecialist}
        onChange={(userId) => onChange(userId || "")}
        options={[
          { value: "", label: copy.anySpecialist },
          ...(value && !users.some((user) => user.userId === value)
            ? [{ value, label: selectedLabel || copy.selectedSpecialist }]
            : []),
          ...users.map((user) => ({
            value: user.userId,
            label: `${getBookingUserName(user)}${user.title ? ` (${user.title})` : ""}`,
          })),
        ]}
      />
      {!isLoading && !isError && !users.length && (
        <Typography.Text role="status">{emptyMessage || copy.noSpecialists}</Typography.Text>
      )}
      {isError && (
        <Alert
          type="error"
          showIcon
          style={{ marginTop: 8 }}
          message={copy.catalogError}
          action={<Button onClick={onRetry}>{copy.retry}</Button>}
        />
      )}
    </div>
  );
};
